// extracted by mini-css-extract-plugin
export var infoRow = "_ux-2";
export var labelContainer = "_ux-0";
export var rightInfo = "_ux-1";